export default [
    {
        "id": "2-lou-malnatis-deep-dish-pizzas",
        "img": "/images/products/lou-malnatis.avif",
        "name": "Lou Malnati's Pizza",
        "dsc": "Pulled Pork, Beer Braised Brisket, & Quarter Rack of Ribs served with your choice of side",
        "price": 5,
        "rate": 4,
        "country": "Chicago, IL"
    },
    {
        "id": "23699-choose-your-own-thin-crust-pizza-4-pack",
        "img": "/images/products/bartolinis.avif",
        "name": "Bartolini’s",
        "dsc": "Pulled Pork, Beer Braised Brisket, & Quarter Rack of Ribs served with your choice of side",
        "price": 3,
        "rate": 4,
        "country": "Chicago, IL"
    },
    {
        "id": "choose-your-own-new-haven-style-pizza-6-pack",
        "img": "/images/products/zuppardis.avif",
        "name": "Zuppardi's Pizza",
        "dsc": "Pulled Pork, Beer Braised Brisket, & Quarter Rack of Ribs served with your choice of side",
        "price": 4,
        "rate": 4,
        "country": "West Haven, CT"
    },
    {
        "id": "6-lou-malnatis-deep-dish-pizzas",
        "img": "/images/products/lou-malnatis-little.avif",
        "name": "Lou Malnati's Little Pizza",
        "dsc": "Pulled Pork, Beer Braised Brisket, & Quarter Rack of Ribs served with your choice of side",
        "price": 3,
        "rate": 4,
        "country": "Chicago, IL"
    },
    {
        "id": "wood-fired-pizzas-best-seller-4-pack",
        "img": "/images/products/pizzeria-bianco.avif",
        "name": "Pizzeria Bianco",
        "dsc": "Pulled Pork, Beer Braised Brisket, & Quarter Rack of Ribs served with your choice of side",
        "price": 12,
        "rate": 5,
        "country": "Phoenix, AZ"
    },
    {
        "id": "236991-choose-your-own-deep-dish-pizza-3-pack",
        "img": "/images/products/bartolinis-big.avif",
        "name": "Bartolini’s Big",
        "dsc": "Pulled Pork, Beer Braised Brisket, & Quarter Rack of Ribs served with your choice of side",
        "price": 13,
        "rate": 5,
        "country": "Chicago, IL"
    },
    {
        "id": "choose-your-own-detroit-style-pizza-3-pack",
        "img": "/images/products/emmy-squared.avif",
        "name": "Emmy Squared",
        "dsc": "Pulled Pork, Beer Braised Brisket, & Quarter Rack of Ribs served with your choice of side",
        "price": 89,
        "rate": 4,
        "country": "Brooklyn, NY"
    },
    {
        "id": "brooklyn-pizza-choose-your-own-5-pack",
        "img": "/images/products/paesans-pizza.avif",
        "name": "Paesan’s Pizza",
        "dsc": "Pulled Pork, Beer Braised Brisket, & Quarter Rack of Ribs served with your choice of side",
        "price": 9,
        "rate": 4,
        "country": "Albany, NY"
    },
    {
        "id": "choose-your-own-chicago-deep-dish-pizza-4-pack",
        "img": "/images/products/my-pi-pizza.avif",
        "name": "My Pi Pizza",
        "dsc": "Chicago Deep Dish Pizza - 4 Pack",
        "price": 19,
        "rate": 5,
        "country": "Chicago, IL"
    },
    {
        "id": "4-lou-malnatis-deep-dish-pizzas",
        "img": "/images/products/lou-malnatis-big.avif",
        "name": "Lou Malnati's Pizza Big",
        "dsc": "4 Lou Malnati's Deep Dish Pizzas",
        "price": 9,
        "rate": 4,
        "country": "Chicago, IL"
    },
    {
        "id": "tonys-custom-pizza-3-pack",
        "img": "/images/products/tonys-pizza-papoletana.avif",
        "name": "Tony's Pizza Napoletana",
        "dsc": "Choose Your Own Pizza - 3 Pack",
        "price": 11,
        "rate": 5,
        "country": "San Francisco, CA"
    },
    {
        "id": "plain-thin-crust-pizza-4-pack",
        "img": "/images/products/the-columbia-inn.avif",
        "name": "The Columbia Inn",
        "dsc": "Plain Thin Crust Pizza - 4 Pack",
        "price": 7,
        "rate": 5,
        "country": "Montville, NJ"
    }
]